/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {
  makeStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  withStyles
} from '@material-ui/core';
import {GenericObject} from '@ion/core/src/types/entities';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {isCurrentTheme} from '@ion/dls/src/theme/useThemeContext';
import {DLSTheme} from '@ion/dls/src/types/types';
import ShockSensorHistoryItem from './ShockSensorHistoryItem';

export interface ShockSensorEventStepperProps {
  data: GenericObject[];
}

const useStyles = makeStyles((theme: DLSTheme) => {
  return {
    stepper : {
      width   : '100%',
      padding : '0px'
    }
  };
});

const EventStepConnector = withStyles(theme => ({
  vertical : {
    marginLeft : 3,
    padding    : 0,
    position   : 'relative'
  },
  lineVertical : {
    minHeight : 52,
    position  : 'absolute',
    top       : -26,
    left      : 0.6
  }
}))(StepConnector);

const SensorStepIcon = function() {
  return (
    <div style={{
      width           : 8,
      height          : 8,
      borderRadius    : '50%',
      backgroundColor : 'currentcolor',
      color           : dlsColor('caGreen')
    }} />
  );
};

const ShockSensorEventStepper = ({data}: ShockSensorEventStepperProps) => {
  const classes   = useStyles();
  const isCurrent = isCurrentTheme();
  const threshold = data?.[0]?.settings?.maxImpact;

  return (
    <div className={classes.stepper}>
      <Stepper style={{padding: isCurrent ? 0 : '15px 0'}}
        connector={<EventStepConnector />}
        orientation='vertical'
        activeStep={0}>
        {data?.map((item, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={SensorStepIcon}>
              <ShockSensorHistoryItem item={item}
                index={index}
                maxImpact={threshold} />
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default memo(ShockSensorEventStepper);
